import React from "react";
import { Navbar, Container, Button } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthContext";
import { useTheme } from "../../../contexts/ThemeContext";
import styles from "./Header.module.css";

const Header = () => {
  const { admin, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <Navbar
      bg={theme === "light" ? "light" : "dark"}
      expand="lg"
      className={styles.header}
      fixed="top"
    >
      <Container fluid>
        <Navbar.Brand className={styles.brand}>Connect Admin</Navbar.Brand>
        <div className="d-flex align-items-center gap-2 ms-auto">
          <Button variant="outline-secondary" size="sm" onClick={toggleTheme}>
            {theme === "light" ? "Тёмная тема" : "Светлая тема"}
          </Button>
          <span className={styles.adminName}>
            {admin?.name || "Администратор"}
          </span>
          <Button variant="outline-danger" size="sm" onClick={logout}>
            Выйти
          </Button>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
